import './_header.scss'
import React from 'react';
import Link from 'gatsby-link'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars,faSearch } from '@fortawesome/free-solid-svg-icons'
import logo from "../../images/logo.png"
library.add(faBars)
library.add(faSearch)

function PaidUser(props) {
  return (
    <div className="paid-header">
      <img className="mr-3 logo" src={logo} width="80" alt="Logo" />
      <h1 className="navbar-brand mt-2"> {props.leagueName}</h1>
    </div>
  );
}

function FreeUser(props) {
  return (
    <>

      <a className="mr-1" target="_blank" href="https://www.patreon.com/bePatron?u=13567542" rel="noopener noreferrer" data-patreon-widget-type="become-patron-button">
        <img className="mr-2" src="https://fantasy-franchise.com/img/patreon.jpg" width="40" alt="Patreon" />
      </a>
      <a className="mr-1" target="_blank" href="https://www.paypal.com/paypalme2/FabianBrenes" rel="noopener noreferrer">
        <img className="mr-1" src="https://www.paypalobjects.com/webstatic/icon/pp258.png" width="40" alt="Paypal.me" />
      </a>
      <Link className="navbar-brand mr-1" to="/support">Support the site</Link>
    </>
  );
}

function Paid(props) {
  const paid = props.paid;
  const leagueName = props.leagueName;

  if (paid) {
    return <PaidUser leagueName={leagueName} />;
  }
  return <FreeUser />;
}

const Header = (props) =>
  ( 
  <nav className="navbar navbar-expand navbar-dark bg-dark static-top">
    <button className="btn btn-link btn-lg text-white " id="sidebarToggle" href="#"  onClick={props.triggerhappy}>
      <FontAwesomeIcon icon="bars" className="fa-lg" />
    </button>
    <Paid paid={props.paid} leagueName={props.leagueName} />
  </nav>
  );

export default Header;
